<template>
    <svg
        width="131"
        height="124"
        viewBox="0 0 131 124"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M130.438 35.1089C129.666 38.2838 125.272 41.515 118.175 44.2539C122.595 41.3912 125.259 38.0196 125.259 34.1395V27.4297C128.233 29.3423 131.177 32.062 130.438 35.1089Z"
            :fill="backgroundColor"
        />
        <path
            d="M60.5723 0.609375C96.2723 0.609375 121.145 9.75049 121.145 17.9563C121.145 26.1611 96.2624 35.3075 60.5723 35.3075C24.8759 35.3075 0 26.1625 0 17.9563C0 9.75014 24.8738 0.609375 60.5723 0.609375Z"
            :fill="backgroundColor"
        />
        <path
            d="M0 25.8164C9.79408 34.6826 35.7668 39.4096 60.5723 39.4096C85.3803 39.4096 111.352 34.6907 121.145 25.8164V34.1367C121.145 42.3372 96.2624 51.4878 60.5723 51.4878C24.8759 51.4878 0 42.3386 0 34.1367V25.8164Z"
            :fill="backgroundColor"
        />
        <path
            d="M5.30148 45.653V50.3265C5.30148 53.4973 7.09999 56.3228 10.1345 58.8143C5.1114 56.3338 2.32707 53.6937 1.71952 51.3357C1.21901 49.3928 2.2654 47.3771 4.65102 45.3242C4.85727 45.4438 5.09514 45.5387 5.30141 45.6528L5.30148 45.653Z"
            :fill="backgroundColor"
        />
        <path
            d="M1.60843 66.5174V58.1602C7.73536 63.6588 20.3965 67.9915 37.5407 70.2299C45.3685 71.2529 53.7451 71.7823 62.1765 71.7823C63.2037 71.7823 64.2377 71.7246 65.2731 71.7081C66.8461 71.7452 68.415 71.7823 69.9881 71.7823C89.7456 71.7823 110.271 68.7889 122.76 63.0963V66.5174C122.76 74.7179 97.8863 83.8643 62.1878 83.8643C26.4843 83.8588 1.6084 74.726 1.6084 66.5174H1.60843Z"
            :fill="backgroundColor"
        />
        <path
            d="M62.1847 87.9646C63.4455 87.9646 64.7064 87.9316 65.9715 87.9068C65.9962 87.9068 66.0169 87.9233 66.0457 87.9233C67.286 87.9481 68.5221 87.9605 69.7664 87.9605C94.8697 87.9605 120.764 83.0821 130.568 74.293V82.6998C130.568 90.9046 105.685 100.047 69.9952 100.047C34.2988 100.047 9.42285 90.9057 9.42285 82.6998V79.2788C21.9009 84.9756 42.4215 87.9648 62.1878 87.9648L62.1847 87.9646Z"
            :fill="backgroundColor"
        />
        <path
            d="M69.981 116.23C34.2916 116.23 9.40869 107.085 9.40869 98.8789V90.5586C19.2028 99.4248 45.1755 104.152 69.981 104.152C94.7865 104.152 120.761 99.4329 130.553 90.5586V98.8789C130.558 107.089 105.68 116.23 69.981 116.23Z"
            :fill="backgroundColor"
        />
        <path
            d="M130.473 67.3147C129.952 69.9341 126.965 72.5919 122.033 74.9982C125.063 72.5094 126.862 69.6837 126.862 66.5185V60.9375C128.999 62.5793 130.978 64.8341 130.473 67.3147Z"
            :fill="backgroundColor"
        />
        <path
            d="M125.794 56.6913C125.786 56.6996 125.77 56.7037 125.761 56.7119C117.129 62.502 97.4335 67.4012 71.944 67.6405C71.6649 67.5168 71.3487 67.4315 71.0118 67.4769C69.1762 67.5635 67.3323 67.5718 65.4885 67.6006C32.2287 66.8692 9.40421 58.1804 9.40421 50.328L9.40283 47.5779C22.002 52.8263 41.619 55.5902 60.5627 55.5902C62.0944 55.5902 63.6303 55.5572 65.1661 55.5201C65.1868 55.5201 65.1991 55.5324 65.2198 55.5324C66.7144 55.5696 68.2131 55.5861 69.712 55.5861C94.8403 55.5861 120.759 50.7158 130.548 41.9062V50.3254C130.558 52.4484 128.867 54.6209 125.795 56.6917L125.794 56.6913Z"
            :fill="backgroundColor"
        />
        <path
            d="M46.3522 6.43141C46.5137 5.4266 45.83 4.48112 44.8252 4.31963C43.8204 4.15814 42.8749 4.84178 42.7134 5.84659L46.3522 6.43141ZM92.2451 17.0485C93.1812 16.6492 93.6164 15.5667 93.2171 14.6306C92.8179 13.6945 91.7353 13.2593 90.7992 13.6585L92.2451 17.0485ZM41.7688 23.3368L39.9494 23.0444C39.84 23.7252 40.1198 24.4101 40.6746 24.8195C41.2294 25.2289 41.9663 25.2944 42.5846 24.9891L41.7688 23.3368ZM66.6454 11.0538L68.4825 11.1979C68.5343 10.5372 68.2274 9.89959 67.6786 9.52801C67.1299 9.15644 66.4238 9.10815 65.8296 9.40156L66.6454 11.0538ZM65.417 26.7174L63.5799 26.5733C63.5292 27.2198 63.8221 27.8453 64.3511 28.2205C64.88 28.5956 65.5673 28.6651 66.1606 28.4034L65.417 26.7174ZM81.2337 19.7418L80.5107 18.0468L80.5004 18.0512L80.4901 18.0558L81.2337 19.7418ZM42.7134 5.84659L39.9494 23.0444L43.5881 23.6292L46.3522 6.43141L42.7134 5.84659ZM42.5846 24.9891L67.4612 12.7061L65.8296 9.40156L40.9529 21.6845L42.5846 24.9891ZM64.8083 10.9098L63.5799 26.5733L67.2541 26.8614L68.4825 11.1979L64.8083 10.9098ZM66.1606 28.4034L81.9772 21.4278L80.4901 18.0558L64.6734 25.0313L66.1606 28.4034ZM81.9566 21.4368L92.2451 17.0485L90.7992 13.6585L80.5107 18.0468L81.9566 21.4368Z"
            fill="white"
        />
        <circle cx="24" cy="100" r="24" fill="#073B5D" />
        <path
            d="M14.9609 99.5979C14.3376 98.9668 13.3207 98.9606 12.6897 99.584C12.0586 100.207 12.0524 101.224 12.6758 101.855L14.9609 99.5979ZM37.6793 92.9551C38.3076 92.329 38.3094 91.3121 37.6833 90.6838C37.0572 90.0555 36.0403 90.0537 35.412 90.6798L37.6793 92.9551ZM20.6575 107.65L19.5149 108.779C19.8151 109.082 20.224 109.254 20.6512 109.256C21.0783 109.258 21.4886 109.089 21.7912 108.788L20.6575 107.65ZM12.6758 101.855L19.5149 108.779L21.8001 106.521L14.9609 99.5979L12.6758 101.855ZM21.7912 108.788L37.6793 92.9551L35.412 90.6798L19.5238 106.512L21.7912 108.788Z"
            fill="white"
        />
    </svg>
</template>

<script>
export default {
    props: {
        backgroundColor: {
            type: String,
            default: "#2A8176"
        }
    }
};
</script>

<style></style>
